import { useMutation } from '@apollo/client';
import { Button } from '@mui/material';
import { RESET_PROFILE_PHOTO_APPROVAL } from '../../graphql/mutations-gql';
import { USER } from '../../graphql/queries-gql';
import { useDismissableSnackbar } from '../../hooks/useDismissableSnackbar';

export default function ResetProfilePhotoApproval({
  userId,
  approved,
}: {
  userId: string;
  approved: boolean | null | undefined;
}) {
  const { showSnackbar } = useDismissableSnackbar();
  const [resetApproval, { loading }] = useMutation<
    { resetProfilePhotoApproval: string | null },
    { userId: string }
  >(RESET_PROFILE_PHOTO_APPROVAL, {
    refetchQueries: [{ query: USER, variables: { _id: userId } }],
    awaitRefetchQueries: true,
  });

  const handleReset = async () => {
    if (loading || approved === false) return;
    try {
      await resetApproval({ variables: { userId } });
      showSnackbar('Profile photo approval reset', 'success');
    } catch (cause: unknown) {
      showSnackbar(
        cause instanceof Error ? cause.message : 'Could not reset profile photo approval. Please try again.',
        'error',
      );
    }
  };

  return (
    <Button
      size="small"
      variant="outlined"
      color="warning"
      disabled={loading || approved === false}
      onClick={handleReset}
    >
      {loading ? 'Resetting...' : 'Reset photo approval'}
    </Button>
  );
}
